import TabsComponent from 'components/shared/Tabs/tabs.component';

export default TabsComponent;
